<template>
    <div class="Turntable">
        <div class="mainGame">
            <navigation-bar BackTo :go-back-to-func=" () => goToPage() "/>
            <div class="content">
                <!--小標-->
                <h3>{{settings.subtitle}}</h3>

                <!--大標-->
                <h2>{{settings.title}}</h2>

                <div class="pointer">
                    <div class="con"/>
                </div>

                <div class="awards" ref="awards">
                    <div class="sector" v-for="(item , index) in settings.giftList" :key="index" :class="'S'+settings.giftList.length">
                        <!--槓龜欄位-->
                        <template v-if="item.missed===true">
                            <div class="missed">
                                <div class="unit">{{item.unit}}</div>
                                <img src="@/assets/images/game/turntable/missed.svg">
                            </div>
                        </template>
                        <!--獎項欄位-->
                        <template  v-else>
                            <div class="title">{{item.title}}</div>
                            <div class="unit">{{item.subtitle}}</div>
                            <div class="type">{{item.type}}</div>
                        </template>

                    </div>
                </div>
                <div class="go">
                    <button @click="toDraw"/>
                </div>
            </div>
            <div class="amount">抽獎機會剩餘 {{settings.limitNumber}} 次</div>
        </div>

        <div class="closeGame" @click="goToPage()"/>

        <comm-dialog :value="isShowDialog"
                     :outerContent="dialogMsg"
                     :mainContent="dialogMsgMain"
                     :icon="icons"
                     :isCancel="false"
                     :close-on-click-modal="false"
                     @result="onDialogResult">
        </comm-dialog>

    </div>
</template>

<script>
    import CommDialog from '@/components/CommDialog.vue';
    import {SpinnerWheelType} from "@/store/constDefine"
    //todo 轉盤參考這網址寫的 https://www.796t.com/article.php?id=265611
    export default {
        name: 'Turntable',
        components: {
            CommDialog,
        },
        data() {
            return {
                params: this.$route.params, // {settingData: GetWheelGame的回傳資料 , type: 轉盤遊戲適用時機}

                //當前角度
                rotate: 0,
                resetRotate: 0,
                //命中的獎項
                hitId: 1,
                //判斷轉盤是否正在轉
                drawStatus: false,
                //轉盤背景色-單數
                bgColor1:'#ffffff',
                //轉盤背景色-偶數
                bgColor2:'#BC0F60',
                //彈窗
                isShowDialog: false,
                //彈框大標
                dialogMsg: '',
                //彈框小標
                dialogMsgMain: '',
                //彈框圖示
                icons: '',
                settings: {
                    id: 0,
                    title: '',
                    subtitle: '',
                    limitNumber: 0,
                    giftList: [],

                    type: 0,
                },
                sound: null,
            }
        },
        created() {
            let shoppingWheelGameType = window.sessionStorage.getItem('shoppingWheelGameType');
            if (this.params.settingData === undefined || this.params.settingData === '{}' || this.params.type === undefined) {
                if (shoppingWheelGameType) {
                    this.params.type = this.$crypto.uriComponentToObject(shoppingWheelGameType);
                    this.goToPage();
                    return;
                } else {
                    this.$router.go(-1);
                    return;
                }
            } else {
                if (shoppingWheelGameType === null) {
                    window.sessionStorage.setItem('shoppingWheelGameType', this.$crypto.objectToURIComponent(this.params.type));
                }
            }
            this.settings = {...JSON.parse(this.params.settingData)};
            this.settings.type = Number(this.params.type);
        },
        mounted() {
            this.setConfig();
            let evenTransition = this.whichTransitionEvent();
            let img = this.$refs.awards;
            let that = this;
            // 監聽 動畫結束
            img.addEventListener(evenTransition, tranHand, false);
            function tranHand() {
                // 抽獎完復位
                that.resetRotate = that.rotate > 360 ? that.rotate % 360 : 0;
                img.style.transition = "none 0s ease 0s";
                img.style.transform = `rotate(${that.resetRotate}deg)`;
                that.drawStatus = false
                // 抽獎完畢後彈窗回饋
                that.isShowDialog=true
                that.icons = require('@/assets/images/dialog_ticket.svg')
                if (that.settings.giftList[that.hitId-1].missed) {
                    that.dialogMsg = `銘謝惠顧<br> 再接再厲，祝您下次中獎`;
                    that.dialogMsgMain = "";
                } else {
                    that.dialogMsg = `恭喜您獲得<br>
                        <span class='red'>
                            ${that.settings.giftList[that.hitId-1].title} <br>
                            ${that.settings.giftList[that.hitId-1].subtitle === '' ? '' : that.settings.giftList[that.hitId-1].subtitle + '<br>'}
                            ${that.settings.giftList[that.hitId-1].type} ${that.settings.giftList[that.hitId-1].number} 張
                        </span>`;
                    that.dialogMsgMain = "票券已經發送至您的禮物盒<br>請前往查看";
                }
            }
            if (navigator.userAgent.indexOf("Android") > -1 || navigator.platform.match(/iPhone|iPod|iPad/)){
                //TODO 聲音用cordova-plugin-media外掛播放，ios才不會有播放bar且關閉app還播放，路徑要放在最外層public
                that.sound = new window.Media("/spinning.mp3")
                that.sound.setVolume('0.2');
                that.sound.play({ numberOfLoops: -1 , playAudioWhenScreenIsLocked : false })
            }

        },
        destroyed() {
            if (navigator.userAgent.indexOf("Android") > -1 || navigator.platform.match(/iPhone|iPod|iPad/)){
                this.sound.stop();
            }
        },
        methods: {
            //數量角度寫入css
            setConfig(){
                //轉盤背景色-單數
                this.$el.style.setProperty('--bgColor1', `${this.bgColor1}`);
                //轉盤背景色-偶數
                this.$el.style.setProperty('--bgColor2', `${this.bgColor2}`);
                //獎項數量
                this.$el.style.setProperty('--awardsNum', `${this.settings.giftList.length}`);
            },
            start() {
                this.$refs.awards.style.transition = "all 3s ease 0s";
                this.$refs.awards.style.transform = `rotate(${this.rotate}deg)`;
            },
            toDraw() {
                if (this.drawStatus) {
                    return
                }
                this.drawStatus = true
                //基數 4圈 360*4
                let reset = 360 * 4;

                this.spinWheelGame().then(data => {
                    this.settings.limitNumber --;

                    let idx = data.data.index;
                    this.hitId = idx;
                    // 需要多轉角度
                    let addRotate = this.resetRotate > 0 ? 360 - this.resetRotate : 0;
                    // 總共角度
                    let allRotate = this.rotate + (idx - 1) * (360/this.settings.giftList.length) + reset + addRotate;
                    // 角度限制
                    this.rotate = this.setRotate(allRotate);
                    this.start();
                });

            },// 遞迴計算角度 不超過 360*6
            setRotate(deg) {
                let rest = deg - 360;
                return rest > 360 * 6 ? this.setRotate(rest) : deg;
            },
            // 動畫相容
            whichTransitionEvent() {
                let el = document.createElement('span'), transitions = {
                    'transition': 'transitionend',
                    'WebkitTransition': 'webkitTransitionEnd'
                };
                for (let t in transitions) {
                    if (el.style[t] !== undefined) {
                        return transitions[t];
                    }
                }
                el = null;
            },
            /** dialog事件 返回 */
            onDialogResult() {
                this.isShowDialog = false;
                if(this.settings.limitNumber === 0){
                   this.goToPage();
                }
            },
            spinWheelGame() {
                return new Promise((resolve, reject) => {
                    this.$http.fetchWithAuth`SpinWheelGame${{
                        "settingId": this.settings.id,
                        "type": this.settings.type,
                    }}
                    ${json => {
                        if (json.status) {
                            resolve(json.data);
                        } else {
                            reject();
                        }
                    }}`;
                })
            },
            goToPage() {
                if (Number(this.params.type) === SpinnerWheelType.HOMEPAGE.VALUE) {
                    this.$router.replace({name: 'Home', params: {from: this.$route.name}});
                    window.sessionStorage.removeItem('shoppingWheelGameType');
                } else if (Number(this.params.type) === SpinnerWheelType.SHOPPING_AREA.VALUE) {
                    this.$router.replace({name: 'MarketplaceInfo',
                        params: {officialName: sessionStorage.getItem('openShoppingAreaOfficialName')}});
                    window.sessionStorage.removeItem('shoppingWheelGameType');
                }
            }
        }
    }
</script>

<style lang="less" scoped src="../../less/turntable.less"/>